import GprdHelper from './components/gpdr-helper.js';
import waitForPolyfills from './polyfill-helper';
import Navigation from './components/navigation';
import CheckBodyScroll from './components/check-body-scroll';
import Sliders from './components/sliders';
import SupplierGrid from './components/supplier-grid';

console.log('BEFORE POLYFILL');
waitForPolyfills(main);

function main() {
    console.info('DOM Ready');
    const gpdr = new GprdHelper();
    gpdr.initGoogleAnalytics(window.UA_CODE);
    gpdr.showCookieConsent('de');

    Navigation.init();
    Sliders.init();
    CheckBodyScroll.init();
    SupplierGrid.init();
};
